import { render, staticRenderFns } from "./ProductRegistrationStep.vue?vue&type=template&id=611fd8d2"
import script from "./ProductRegistrationStep.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports